import * as React from 'react';

import FolderShared16 from './FolderShared16';

export const folderShared16 = () => <FolderShared16 />;

export default {
    title: 'Icon|Fill|FolderShared16',
    component: FolderShared16,
    parameters: {
        notes: "`import FolderShared16 from 'box-ui-elements/es/icon/fill/FolderShared16';`",
    },
};
